// Dependiendo del valor numérico aplicaremos diferentes estilos/alineamientos de items
export const APP_SWITCH_APPEARANCE = {

    // ------------------------------- 🔥 THEME CONFIG (NUEVO: Control global de tema)
    THEME: {
        MODE: "DARK", // NOTEBOOK es dark-only
        PRIMARY_COLOR_VARIANT: 1,
        AESTHETIC: 1,
    },

    // ------------------------------- 🔥 BRAND CONFIG
    /*
        🔥 DE DÓNDE SALE EL LOGO

        ACÁ NO SE DEFINE NINGUNA RUTA DE IMAGEN. La imagen sale siempre de:

            _Config/_Company/AppCompanyConfig.js  → COMPANY_IMGS (las rutas, en public/_Imgs/)
            _Config/_Company/_GetLogo.js          → GET_ACTIVE_LOGO() elige cuál según la fecha

        Este bloque sólo decide CÓMO se muestra. La cadena completa es:

            AppCompanyConfig.COMPANY_IMGS
                    ↓
            _GetLogo.GET_ACTIVE_LOGO()  → { id, assets: { light, dark } }
                    ↓
            AppShell.Layout.onBuildBrandSlot()  → arma un slot por zona
                    ↓
            HeaderShell / SidebarPrivate / FooterPublic  → dibujan las DOS imágenes
                    ↓
            el CSS muestra una según html[data-theme]

        ⚠️ CAMPO POR CAMPO

            isLogo       true dibuja la imagen y NO se renderiza el nombre en texto.
                         false hace lo contrario. Nunca los dos juntos.

            isCelebrate  true respeta el calendario de _GetLogo (navidad, bandera, etc.).
                         false usa siempre BRAND_LIGHT / BRAND_DARK, el institucional.

            appearance   1 a 25. Sólo cambia altura y encuadre del logo. En el sidebar el
                         encuadre queda centrado siempre.

            width        "auto" deja mandar al nivel de appearance.
            height       Un valor concreto ("500px", "60px") PISA al nivel de appearance.

                         ⚠️ WIDTH Y HEIGHT SON LA CAJA, NO EL LOGO.

                         El logo lleva object-fit: contain, así que respeta su proporción
                         (749x345) y se acomoda DENTRO de la caja sin deformarse.

                         Con width: "500px" y height: "40px" la caja mide 500x40, pero el
                         logo a 40 de alto ocupa ~87 de ancho: los otros ~413 son aire, y
                         por eso parece corrido. No lo agranda.

                         PARA AGRANDARLO, FIJÁ UNA SOLA MEDIDA Y DEJÁ LA OTRA EN "auto":

                             width: "auto",  height: "60px"   → 60 de alto, ancho calculado
                             width: "500px", height: "auto"   → 500 de ancho, alto calculado

                         Si igual querés caja grande, el aire lo controla el nivel de
                         appearance: 1 a 5 pegan el logo a la izquierda, 6 a 10 lo centran,
                         11 a 15 lo mandan a la derecha.

            internal_link  Destino interno del click (react-router).
            external_link  Si tiene valor, GANA: abre en pestaña nueva en vez de navegar.

            title / alt    Van al <img> y al enlace. alt es el que lee un lector de pantalla.
    */
    BRAND: {

        /*
            🔥 DÓNDE SE DIBUJA CADA SLOT

                HEADER_PUBLIC   → header de las vistas públicas (AppLayoutPublic)
                HEADER_PRIVATE  → header del panel Y el brand del sidebar (AppLayoutPrivate)
                FOOTER_PUBLIC   → footer de las vistas públicas
                FOOTER_PRIVATE  → footer del panel (AppLayoutPrivate)

            ⚠️ PARA AGRANDAR EL LOGO SE TOCA "height", NUNCA "width".

               El logo lleva object-fit: contain y respeta su proporción (749x345).
               Con height: "80px" queda 174x80. Con width: "1500px" y height: "40px"
               la caja mide 1500 pero el logo sigue en 87x40: sólo agregás aire.

               width sirve para reservar espacio o forzar una caja, no para agrandar.
        */
        HEADER_PUBLIC: {
            // NOTEBOOK: logo institucional visible en todas las superficies publicas.
            isLogo: true, isCelebrate: false,
            appearance: 1, width: "180px", height: "auto",
            external_link: "", internal_link: "/",
            title: "NOTEBOOK", alt: "NOTEBOOK",
        },

        HEADER_PRIVATE: {
            // NOTEBOOK: este mismo slot alimenta header privado y sidebar.
            isLogo: true, isCelebrate: false,
            appearance: 1, width: "150px",
            height: "auto", external_link: "", internal_link: "/dashboard",
            title: "NOTEBOOK", alt: "NOTEBOOK",
        },

        FOOTER_PUBLIC: {
            isLogo: true, isCelebrate: false,
            appearance: 1, width: "145px", height: "auto",
            external_link: "", internal_link: "/",
            title: "NOTEBOOK", alt: "NOTEBOOK",
        },

        FOOTER_PRIVATE: {
            isLogo: true, isCelebrate: false,
            appearance: 1, width: "145px", height: "auto",
            external_link: "", internal_link: "/dashboard",
            title: "NOTEBOOK", alt: "NOTEBOOK",
        },
    },

    // ------------------------------- 🔥 LAYOUT CONFIG
    /*
        🔥 ANCHO DEL CONTENEDOR DE CONTENIDO

        PUBLIC, PRIVATE y DASHBOARD combinan ANCHO MÁXIMO y MARGEN INTERNO.
        Los 25 niveles salen de cruzar 5 anchos con 5 márgenes:

            anchos    1280px · 1120px · 1440px · 1600px · sin tope
            márgenes  24px · 12px · 40px · 64px · 0px

        Referencia rápida:

            1   1280px con 24px   (el clásico, contenido centrado)
            3   1440px con 24px
            5   sin tope con 24px
            21  1280px sin margen
            25  SIN TOPE Y SIN MARGEN  → ancho completo, de borde a borde

        AUTH no es un ancho: es la proporción entre el panel visual y el
        formulario. Está explicado en STYLES > AUTH_PORTAL_CLIENT.
    */
    LAYOUT: {
        AUTH: 1, PUBLIC: 25, PRIVATE: 25, DASHBOARD: 25, FONT_APP: 1, STRUCTURE: 1,
    },

    // ------------------------------- 🔥 STYLES CONFIG
    STYLES: {
        // --------------------------------------- 🔥 HEADERS & FOOTERS
        FOOTER_PUBLIC: 1,
        HEADER_TOP_PUBLIC: 4,
        HEADER_TOP_EXTRA_AD_PUBLIC: 1,
        HEADER_TOP_EXTRA_OFFERS_PUBLIC: 1,
        HEADER_TOP_EXTRA_CELEBRITY_PUBLIC: 1,

        FOOTER_PRIVATE: 1,
        HEADER_TOP_PRIVATE: 1,
        HEADER_TOP_EXTRA_AD_PRIVATE: 1,
        HEADER_TOP_EXTRA_OFFERS_PRIVATE: 1,
        HEADER_TOP_EXTRA_CELEBRITY_PRIVATE: 1,

        // --------------------------------------- 🔥 VIEWS
        // ------------- 🎯 HOME
        HOME_HERO: 1, HOME_CONTACT: 1, HOME_SERVICES: 1,
        HOME_PROJECTS: 1, HOME_ABOUT_ME: 1,

        // ------------- 🎯 BLOG 
        BLOG_GRID: 1, BLOG_CARD: 1, BLOG_SINGLE_POST: 1,

        // ------------- 🎯 WORK WITH US  
        WORK_WITH_US_FORM: 1,

        // ------------- 🎯 AUTH (COMPLETADO)
        // PORTAL - CLIENT
        AUTH_PORTAL_CLIENT: 1,

        // STAFF
        AUTH_STAFF_LOGIN: 1,

        // ------------- 🎯 DASHBOARD / PRIVATE 
        DASHBOARD_CARDS: 1, DASHBOARD_TABLES: 1, DASHBOARD_SIDEBAR: 1,

        // ------------- 🎯 LIBRERIAS
        ALERT: 1, ALERT_POSITION: 1, CONFIRM_ALERT: 1, RICH_EDITOR: 1,
    },

    // ------------------------------- 🔥 ALIGN CONFIG
    ALIGN: {
        FOOTER_PUBLIC_ITEMS: 1,
        FOOTER_PRIVATE_ITEMS: 1,
        NAV_MENU_ITEMS_PUBLIC: 1,
        NAV_MENU_ITEMS_PRIVATE: 1,
        HEADER_TOP_PUBLIC_ITEMS: 1,
        HEADER_TOP_PRIVATE_ITEMS: 3, // portfolio visual: utilidades a la derecha
    },

};